import '../polyfill';
import transitionend from 'gears/support/transitionend/component';
import Datepicker from 'gears/ui/datepicker/component';
import Modal from 'gears/ui/modal/component';
import Popover from 'gears/ui/popover/component';
import Waiting from 'gears/ui/waiting/component';
import Alert from 'gears/ui/alert/component';

window.Gears = {
  init: () => {
    window.Gears.ui.Alert.className = 'gears-alert';
  },
  support: {
    transitionend
  },
  ui: {
    Datepicker,
    Modal,
    Popover,
    Waiting,
    Alert,
  },
};
